import { getParsedICUMessages } from '../../icu-handler/dist/vocab-core-icu-handler.esm.js';
export { createTranslationFile } from '../../translation-file/dist/vocab-core-translation-file.esm.js';
import 'intl-messageformat';

const createLanguage = module => ({
  getValue: locale => getParsedICUMessages(module, locale),
  load: () => Promise.resolve()
});

export { createLanguage };
